// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3_URr","options":"AnswerScale_options__1fw3j","selected":"AnswerScale_selected__1m6j1"};